import { Row, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import API from "../services/api-request";

const SelectProduct = ({ value, onChange, nullOptions, idClient }) => {
  const [listData, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getProduct = async () => {
    setLoading(true);
    API.Get(`product${idClient ? "?client_id=" + idClient : ""}`)
      .then((res) => {
        const newData = res?.data;
        const filteredData = newData.filter(
          (item) =>
            !listData.find((existingItem) => existingItem.id === item.id)
        );
        setData((prevData) => [...prevData, ...filteredData]);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getProduct();
  }, [nullOptions, idClient]);

  return (
    <Select
      style={{ width: "100%" }}
      allowClear
      showSearch
      value={value || null}
      optionFilterProp="label"
      placeholder={nullOptions ? "Pilih Client Dahulu" : "Pilih Produk"}
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={
        nullOptions
          ? null
          : listData?.map((e) => ({
              label: e.name,
              value: e.id,
            }))
      }
    />
  );
};

export default SelectProduct;
